import { render, staticRenderFns } from "./getVirtualMoneyRecord.vue?vue&type=template&id=3129403b&"
import script from "./getVirtualMoneyRecord.vue?vue&type=script&lang=js&"
export * from "./getVirtualMoneyRecord.vue?vue&type=script&lang=js&"
import style0 from "./getVirtualMoneyRecord.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports